import React, { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import MuiLink, { LinkProps as MuiLinkProps } from '@material-ui/core/Link';

type RouterLinkProps = Omit<LinkProps, 'component'> &
  Omit<MuiLinkProps, 'component' | 'href'>;

const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(
  (props: RouterLinkProps, ref) => (
    <MuiLink {...props} component={Link} ref={ref} />
  ),
);

export default RouterLink;
